import { render, staticRenderFns } from "./OHeader.vue?vue&type=template&id=53d4913b"
import script from "./OHeader.vue?vue&type=script&lang=js"
export * from "./OHeader.vue?vue&type=script&lang=js"
import style0 from "./OHeader.vue?vue&type=style&index=0&id=53d4913b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports